import type { ReactNode } from 'react';

interface CrawlTooltip {
  expiredCrawl: ReactNode;
  errorCrawl: ReactNode;
  timeout: ReactNode;
  resetTable: ReactNode;
  saveTable: ReactNode;
  crawlSettings: {
    crawlerSettings: Record<string, ReactNode>;
    crawlerSpeed: Record<string, string>;
    crawlerLimit: Record<string, string>;
    crawlerContent: Record<string, string>;
    crawlerUserAgentTooltips: Record<string, string>;
    crawlerIncludeExcludeTooltips: Record<string, string>;
    crawlerAdvancedSelection: Record<string, string>;
  };
  crawlerHistory: Record<string, string>;
  crawlerOverview: Record<string, string>;
  crawlerInternalLinls: Record<string, string>;
  crawlerExternalLinls: Record<string, string>;
  crawlerLinkGraph: Record<string, string>;
  crawlerCheckList: Record<string, string>;
  uriIssueTypes: Record<string, ReactNode>;
  columns: Record<string, ReactNode>;
}

export const crawlTooltip: CrawlTooltip = {
  expiredCrawl: `داده‌ها بعد از ۲ ماه به صورت خودکار حذف شدن.`,
  errorCrawl: (
    <p className="text-start">
      علت خطا:
      <br />
      محدودیت درخواست به سرور
      <br />
      عدم دسترسی به سرور
      <br />
      بلاک کردن ای پی میزفا تولز
      <br />
      موقت بودن خطا
      <br />و ... پیشنهاد میشه{' '}
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://help.mizfa.tools/cause-crawl-error/"
      >
        {' '}
        این مقاله{' '}
      </a>{' '}
      رو مطالعه کنید.{' '}
    </p>
  ),
  timeout: (
    <p className="text-start">
      سرور سایت شما بعد از ۳۰ ثانیه پاسخ نداد. احتمالاً ای پی ابزار خزش توسط
      سرور سایت شما بلاک شده{' '}
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://help.mizfa.tools/fix-crawl-server-ip-block/"
      >
        {' '}
        (این مقاله رو بخونید){' '}
      </a>
      ، یا ممکنه به خاطر داشتن سرور خارج سایت شما، محدودیت دسترسی از داخل ایران
      وجود داشته باشه. همچنین احتمال دارد دامنه یا هاست شما تمدید نشده یا اشتباه
      وارد شده باشد.
    </p>
  ),
  resetTable:
    'تنظیماتی که برای تغییرات و شخصی سازی جدول انجام دادید رو به حالت اولیه برمیگردونه.',
  saveTable: (
    <p>
      ذخیره جدول چه کار میکنه؟ شما میتونید جدول رو شخصی سازی کنید یعنی یک سری
      ستون ها کم و زیاد کنید یا عرض ستون‌ها رو مثل اکسل کم و زیاد کنید، سپس روی
      دکمه ذخیره جدول کلیک کنید. وقتی دوباره وارد میزفا تولز بشید براساس شخصی
      سازی که انجام دادید جدول لود میشه و این کمک بسیار زیادی به افرادی میکنه که
      قصد دارن حرفه ای و با سرعت بالا براساس داده های دلخواه و چیدمان دلخواه
      تحلیل سئویی انجام بدن. جدول میزفا تولز امکانات خیلی زیادی داره حتما ۱۶
      ویدیو کوتاه ۱۰ ثانیه در لینک زیر رو مشاهده کنید:
      <br />
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://help.mizfa.tools/mizfa-tracker-pro/feature-table"
      >
        help.mizfa.tools/mizfa-tracker-pro/feature-table/
      </a>
    </p>
  ),
  crawlSettings: {
    // Field Names are in src/components/dashboard/crawl/modalSettingsConfig.ts
    crawlerSettings: {
      domain_scope: (
        <div className="text-start">
          مشخص می‌کند خزنده کدام نشانی‌ها را دنبال کند.
          <br />
          <br />
          <strong>نشانی دقیق</strong>
          <br />
          فقط همان صفحه‌ای که به‌عنوان نشانی شروع خزش وارد کرده‌اید؛ پیوندهای
          داخلی دیگر دنبال نمی‌شوند.
          <br />
          مثال: اگر{' '}
          <span dir="ltr" className="font-monospace">
            https://example.com/blog/hello/
          </span>{' '}
          را وارد کنید، فقط همین صفحه خزش می‌شود نه{' '}
          <span dir="ltr" className="font-monospace">
            /blog/
          </span>{' '}
          و نه صفحات دیگر.
          <br />
          <br />
          <strong>مسیر</strong>
          <br />
          همان پوشه و همهٔ زیرپوشه‌هایش خزش می‌شوند؛ مسیرهای دیگر همان سایت نه.
          <br />
          مثال: شروع از{' '}
          <span dir="ltr" className="font-monospace">
            https://example.com/blog/
          </span>{' '}
          شامل{' '}
          <span dir="ltr" className="font-monospace">
            /blog/hello/
          </span>{' '}
          می‌شود، ولی{' '}
          <span dir="ltr" className="font-monospace">
            /products/
          </span>{' '}
          را خزش نمی‌کند.
          <br />
          <br />
          <strong>دامنه</strong>
          <br />
          همهٔ صفحات همین هاست خزش می‌شوند؛ زیردامنه‌ها نه. www و بدون www یکی
          حساب می‌شوند.
          <br />
          مثال: شروع از{' '}
          <span dir="ltr" className="font-monospace">
            test.mizto.ir
          </span>{' '}
          همهٔ مسیرهای همین هاست را می‌گیرد، ولی{' '}
          <span dir="ltr" className="font-monospace">
            help.test.mizto.ir
          </span>{' '}
          را نه.
          <br />
          <br />
          <strong>زیردامنه‌ها</strong>
          <br />
          دامنهٔ ریشه و همهٔ زیردامنه‌هایش خزش می‌شوند.
          <br />
          مثال: شروع از{' '}
          <span dir="ltr" className="font-monospace">
            test.mizto.ir
          </span>{' '}
          شامل{' '}
          <span dir="ltr" className="font-monospace">
            mizto.ir
          </span>{' '}
          و{' '}
          <span dir="ltr" className="font-monospace">
            blog.mizto.ir
          </span>{' '}
          هم می‌شود.
        </div>
      ),
      respect_robots_txt:
        'در صورت فعال بودن، دستورهای فایل robots.txt سایت برای تعیین صفحات مجاز و غیرمجاز رعایت می‌شوند.',
      ignore_query:
        'در صورت فعال بودن، پارامترهای نشانی نادیده گرفته می‌شوند تا نشانی‌های تکراری خزش نشوند.',
      ignore_rel_ahref_nofollow:
        'در صورت فعال بودن، پیوندهایی که ویژگی rel=nofollow دارند دنبال و خزش نمی‌شوند.',
      ignore_fragment:
        'در صورت فعال بودن، بخش Fragment نشانی‌ها نادیده گرفته می‌شود.',
      respect_canonical:
        'در صورت فعال بودن، نشانی Canonical صفحه برای تشخیص نشانی اصلی در نظر گرفته می‌شود.',
      respect_pagination:
        'در صورت فعال بودن، پیوندهای صفحه‌بندی مانند rel=next و rel=prev دنبال می‌شوند.',
      ignore_noindex_page:
        'در صورت فعال بودن، صفحاتی که برچسب noindex دارند از خزش کنار گذاشته می‌شوند.',
      custom_encoding_is_enable:
        'برای پردازش محتوای صفحات با رمزگذاری سفارشی، این گزینه را فعال کنید.',
      crawl_image_is_disable:
        'در صورت فعال بودن، تصاویر هنگام خزش بررسی و دریافت نمی‌شوند.',
      crawl_js_is_disable:
        'در صورت فعال بودن، فایل‌های JavaScript هنگام خزش بررسی و دریافت نمی‌شوند.',
      crawl_css_is_disable:
        'در صورت فعال بودن، فایل‌های CSS هنگام خزش بررسی و دریافت نمی‌شوند.'
    },
    crawlerSpeed: {
      concurrent_requests:
        'تعداد درخواست‌هایی را که خزنده به‌صورت هم‌زمان ارسال می‌کند مشخص می‌کند. مثال: 1',
      download_delay:
        'مدت مکث بین درخواست‌های خزنده را برحسب ثانیه مشخص می‌کند. مثال: 2'
    },
    crawlerLimit: {
      depth_high:
        'حداکثر عمق لینک‌هایی را که خزنده دنبال می‌کند مشخص می‌کند. مثال: 16',
      max_crawl_internal_page:
        'حداکثر تعداد صفحات داخلی قابل بررسی را مشخص می‌کند. مثال: 10000',
      redirect_max_times:
        'حداکثر تعداد دفعات دنبال‌کردن تغییر مسیر یک نشانی را مشخص می‌کند. مثال: 10',
      max_crawl_duration_hourly:
        'حداکثر زمان اجرای خزش را برحسب ساعت مشخص می‌کند. مثال: 48',
      bad_response_time:
        'حداکثر زمان قابل‌قبول برای پاسخ سرور را برحسب ثانیه مشخص می‌کند. مثال: 5'
    },
    crawlerContent: {
      low_word:
        'حداقل تعداد کلمات متن صفحه (بدون منو، فوتر و سایدبار). اگر کمتر باشد در فهرست بازبینی به‌عنوان «محتوای کم» علامت می‌خورد. مثال: 500',
      high_word:
        'حداکثر تعداد کلمات متن صفحه. اگر بیشتر باشد به‌عنوان «محتوای زیاد» گزارش می‌شود. مثال: 4000',
      page_old_blog:
        'اگر از آخرین به‌روزرسانی صفحه بیش از این تعداد روز گذشته باشد، صفحه «قدیمی / به‌روز نشده» تشخیص داده می‌شود. مثال: 180',
      page_low_unique_inline:
        'صفحاتی که پیوند داخلی یکتای کمتر از این عدد دارند «صفحه تنها» نامیده می‌شوند. مثال: 5',
      page_high_unique_external_outline:
        'اگر تعداد پیوندهای خروجی خارجی یکتا از این آستانه بیشتر شود هشدار ثبت می‌شود. مثال: 15',
      page_high_size:
        'حداکثر حجم HTML صفحه برحسب کیلوبایت؛ بالاتر از آن «صفحه سنگین» گزارش می‌شود. مثال: 200',
      asset_high_size:
        'حداکثر حجم هر منب (تصویر، CSS، JS و …) برحسب کیلوبایت؛ منابع سنگین‌تر از این مقدار هشدار می‌گیرند. مثال: 200',
      paragraph_similarity_percent:
        'اگر شباهت متن یک پاراگراف با پاراگراف صفحهٔ دیگر از این درصد بیشتر شود، مشکل «متن تکراری» ثبت می‌شود. مثال: 80',
      title_similarity_percent:
        'اگر شباهت عنوان (Title) دو صفحه از این درصد بیشتر شود، «عنوان تکراری» گزارش می‌شود. مثال: 80',
      title_char_is_long:
        'اگر طول عنوان برحسب کاراکتر از این عدد بیشتر شود هشدار «عنوان بلند» ثبت می‌شود. مثال: 60',
      title_px_is_long:
        'اگر عرض نمایشی عنوان در نتایج جستجو (پیکسل) از این مقدار بیشتر شود هشدار «عنوان بلند» ثبت می‌شود. مثال: 600',
      title_char_is_short:
        'اگر طول عنوان برحسب کاراکتر کمتر از این آستانه باشد هشدار «عنوان کوتاه» ثبت می‌شود. مثال: 20',
      title_px_is_short:
        'اگر عرض نمایشی عنوان (پیکسل) کمتر از این مقدار باشد هشدار «عنوان کوتاه» ثبت می‌شود. مثال: 300',
      meta_desc_char_is_long:
        'اگر طول توضیح متا (Meta Description) برحسب کاراکتر از این عدد بیشتر شود هشدار ثبت می‌شود. مثال: 160',
      meta_desc_px_is_long:
        'اگر عرض نمایشی توضیح متا (پیکسل) از این مقدار بیشتر شود هشدار «توضیح متا بلند» ثبت می‌شود. مثال: 900',
      meta_desc_char_is_short:
        'اگر طول توضیح متا برحسب کاراکتر کمتر از این آستانه باشد هشدار «توضیح متا کوتاه» ثبت می‌شود. مثال: 110',
      meta_desc_px_is_short:
        'اگر عرض نمایشی توضیح متا (پیکسل) کمتر از این مقدار باشد هشدار «توضیح متا کوتاه» ثبت می‌شود. مثال: 300',
      density_percent:
        'آستانه چگالی کلمه (درصد). اگر چگالی یک کلمه یا عبارت در صفحه از این مقدار بیشتر شود در گزارش چگالی هشدار می‌گیرید. مثال: 80'
    },
    crawlerUserAgentTooltips: {
      model: 'یک User-Agent آماده را از فهرست انتخاب کنید. برای مقدار دلخواه، گزینه سفارشی را انتخاب کنید.',
      name: 'نام User-Agent سفارشی را مشخص می‌کند.',
      custom:
        'اگر فعال باشد، مقدار واردشده در فیلد User-Agent value به خزنده ارسال می‌شود.',
      value: 'مقدار User-Agent سفارشی را وارد کنید.'
    },
    crawlerIncludeExcludeTooltips: {
      include:
        'فقط نشانی‌هایی که با یکی از الگوها جور باشند خزش می‌شوند. بدون ستاره فقط همان نشانی است (زیرمسیرها نه). ستاره یعنی بقیهٔ نشانی؛ مثلاً https://host/path/* همان مسیر و زیرپوشه‌ها، و *blog* هر نشانی که blog داشته باشد. هر الگو در یک سطر.',
      exclude:
        'نشانی‌هایی که با یکی از الگوها جور باشند خزش نمی‌شوند. بدون ستاره فقط همان نشانی است. ستاره یعنی بقیهٔ نشانی؛ مثلاً */admin/* هر نشانی که /admin/ داشته باشد. هر الگو در یک سطر.'
    },
    crawlerAdvancedSelection: {
      custom_extraction_css:
        'انتخابگرهای CSS برای مشخص‌کردن بخش‌های موردنظر صفحه استفاده می‌شوند. مثال: .price, .description',
      custom_extraction_css_name:
        'نام خروجی هر انتخابگر CSS را مشخص می‌کند. نام‌ها را به همان ترتیب انتخابگرها وارد کنید. مثال: price,description',
      custom_extraction_xpath:
        'انتخابگرهای XPath برای استخراج بخش‌های موردنظر صفحه استفاده می‌شوند. مثال: //div[@class="author"]',
      custom_extraction_xpath_name:
        'نام خروجی هر انتخابگر XPath را مشخص می‌کند. مثال: author'
    }
  },
  crawlerHistory: {
    health_score:
      'سلامت سایت بستگی به تعداد صفحات سالم و تعداد خطاها و هشدارها داره، به عبارت دیگه بخش اطلاعیه اثری روی سلامت سایت نداره، هر چه تعداد صفحات سالم زیاد و تعداد خطاها و هشدارها کمتر باشه سلامت سایت بالاتر میره، عدد بالاتر یعنی بهتر و عدد پایین تر یعنی بدتر. در ضمن تاریخچه 10 خزش اخیر رو میتونی در این بخش مشاهده کنی.',
    crawled_pages:
      'صفحات خزش شده مجموع صفحات داخلی و خارجی منهای تصاویر و منابع سایت هست. تعداد این صفحات بستگی به بودجه خزش، نوع لینک سازی داخلی و نوع پاسخ دهی سرور سایت شما دارد.'
  },
  crawlerOverview: {
    cardStatus:
      'سلامت سایت بستگی به تعداد صفحات سالم و تعداد خطاها و هشدارها داره، به عبارت دیگه بخش اطلاعیه اثری روی سلامت سایت نداره، هر چه تعداد صفحات سالم زیاد و تعداد خطاها و هشدارها کمتر باشه سلامت سایت بالاتر میره، عدد بالاتر یعنی بهتر و عدد پایین یعنی بد.',
    cardInformation:
      'در این بخش اطلاعات خزش رو مشاهده میکنید. تعداد صفحات بستگی به بودجه خزش، نوع لینک سازی داخلی و نوع پاسخ دهی سرور سایت شما دارد.',
    cardChecklist:
      'موارد سایت مجموعه ای از خطاها، هشدارها و اطلاعیه ها است که در بخش فهرست بازبینی میتوان با جزئیات دید.',
    cardCodeDistribution: 'توزیع کد های وضعیت لورم ایپسوم ۳',
    cardProtocolDistribution: 'توزیع پروتکل ها لورم ایپسوم ۴',
    cardAlt: 'تصاویر با alt و بی alt  لورم ایپسوم ۵',
    cardLinkDistribution: 'توزیع آدرس های خزش شده لورم ایپسوم ۶ ',
    cardContentDistribution: 'توزیع نوع محتوا لورم ایپسوم ۷ ',
    cardDepthDistribution: 'توزیع عمق خزش لورم ایپسوم ۸ '
  },
  crawlerInternalLinls: {
    chart: 'نمودار حبابی پیوند داخلی'
  },
  crawlerExternalLinls: {
    chart: 'نمودار پیوند خارجی'
  },
  crawlerLinkGraph: {
    tree: 'نمودار درخت پایه',
    circle: 'نمودار درخت مرکزی',
    graph: 'نمودار گراف '
  },
  crawlerCheckList: {
    errors:
      'تعداد خطاهای کل سایت رو می‌تونید مشاهده کنید.خطاها اهمیت بالایی دارن باید درا بتدا این بخش رو مشاهده کنید.',
    warning:
      'تعداد هشدارها کل سایت رو می‌تونید مشاهده کنید. بعد از خطاها، هشدارها اهمیت زیادی دارن.',
    info: 'تعداد اطلاعیه کل سایت رو می‌تونید مشاهده کنید. در ابتدا خطاها و بعد هشدارها رو بررسی کنید و سپس اطلاعیه ها رو بررسی کنید، داخل بخش اطلاعیه ممکنه خطایی باشه و یا ممکنه خطا نباشه و صرفا اطلاعیه باشه و اثری روی سلامت سایت هم نداره.'
  },
  uriIssueTypes: {
    underscore: (
      <p className="mb-0">
        در مسیر نشانی کاراکتر آندرلاین (<code>_</code>) دیده شده. برای سئو
        معمولاً بهتر است به‌جای آن از خط تیره (<code>-</code>) استفاده شود و
        کلمات در مسیر با خط تیره از هم جدا شوند.
      </p>
    ),
    uppercase: (
      <p className="mb-0">
        در مسیر نشانی حروف بزرگ (Capital) وجود دارد. نشانی‌ها بهتر است یکدست و
        با حروف کوچک باشند تا نسخه‌های مختلف همان صفحه ایجاد نشود.
      </p>
    ),
    multiple_slash: (
      <p className="mb-0">
        در مسیر نشانی دو اسلش پشت‌سرهم (<code>//</code>) وجود دارد. این مورد
        می‌تواند نشانه ساختار نامرتب URL یا لینک‌دهی نادرست باشد.
      </p>
    ),
    whitespace: (
      <p className="mb-0">
        در مسیر نشانی فضای خالی (معمولاً به صورت <code>%20</code>) دیده شده که
        برای کاربر و موتور جستجو نامطلوب است؛ بهتر است از خط تیره یا کلمات
        بدون فاصله استفاده شود.
      </p>
    ),
    query_parameters: (
      <p className="mb-0">
        نشانی پارامتر کوئری (بعد از <code>?</code>) دارد. در برخی موارد می‌تواند
        باعث محتوای تکراری یا تعداد زیاد نسخهٔ یک صفحه شود؛ در فهرست بازبینی
        هم «نشانی با کوئری» قابل بررسی است.
      </p>
    ),
    repetitive: (
      <p className="mb-0">
        یک بخش مسیر (فولدر) در نشانی به‌صورت تکراری در مسیر آمده است. ساختار
        تمیزتر معمولاً بدون تکرار غیرضروری در بخش‌های مسیر است.
      </p>
    ),
    over_limit: (
      <p className="mb-0">
        طول نشانی از حد توصیه‌شده (بیش از ۱۱۵ کاراکتر) است. نشانی‌های خیلی
        بلند ممکن است در نتایج جستجو کوتاه نمایش داده شوند.
      </p>
    ),
    many_paths: (
      <p className="mb-0">
        مسیر نشانی بیش از پنج بخش (فولدر) دارد. عمق زیاد URL می‌تواند نشانه
        ساختار پیچیده یا دسته‌بندی عمیق باشد؛ در صورت امکان ساده‌سازی مسیر مفید
        است.
      </p>
    )
  },
  columns: {
    start_url: (
      <p>در این ستون آدرس‌هایی که برای شروع خزش ثبت شده مشاهده میکنید.</p>
    ),
    health_score:
      'سلامت سایت بستگی به تعداد صفحات سالم و تعداد خطاها و هشدارها داره، به عبارت دیگه بخش اطلاعیه اثری روی سلامت سایت نداره، هر چه تعداد صفحات سالم زیاد و تعداد خطاها و هشدارها کمتر باشه سلامت سایت بالاتر میره، عدد بالاتر یعنی بهتر و عدد پایین تر یعنی بدتر. در ضمن تاریخچه 10 خزش اخیر رو میتونی در این بخش مشاهده کنی.',
    count_error: (
      <p>
        تعداد خطاهای کل سایت رو می‌تونید مشاهده کنید.خطاها اهمیت بالایی دارن
        باید درا بتدا این بخش رو مشاهده کنید.
      </p>
    ),
    count_warning: (
      <p>
        تعداد هشدارها کل سایت رو می‌تونید مشاهده کنید. بعد از خطاها، هشدارها
        اهمیت زیادی دارن.
      </p>
    ),
    count_info: (
      <p>
        تعداد اطلاعیه کل سایت رو می‌تونید مشاهده کنید. در ابتدا خطاها و بعد
        هشدارها رو بررسی کنید و سپس اطلاعیه ها رو بررسی کنید، داخل بخش اطلاعیه
        ممکنه خطایی باشه و یا ممکنه خطا نباشه و صرفا اطلاعیه باشه و اثری روی
        سلامت سایت هم نداره.
      </p>
    ),
    crawl_status: (
      <p>
        وضعیت خزش رو نمایش میده، انواع وضعیت داریم: در حال خزش، پایان، خطا، در
        صف بررسی. اگر خطا خوردید حتما با پشتیبان آنلاین در تماس باشید.
      </p>
    ),
    start_crawl_time_timestamp: <p>تاریخ شروع خزش هست.</p>,
    crawl_duration: (
      <p>
        مدت زمانی که خزش طول کشیده رو مشاهده میکنید، هر چه هاست یا سرور شما کند
        تر باشه یا صفحات بیشتری داشته باشه مدت زمان خزش طولانی‌تر هست.
        <br />
        نمونه فرمت (hh:mm:ss)
        <br />
        عدد سمت چپ ساعت، عدد وسط دقیقه و عدد سمت راست ثانیه هست.
      </p>
    ),
    count_url_total: (
      <p>
        شامل کل نشانی‌های داخلی و خارجی و تصاویر به همراه منابع مثل فایل‌های JS
        و CSS
      </p>
    ),
    count_pages_total: (
      <p>
        تعداد صفحات HTML که میزفا تولز تونسته براساس بودجه خزش شما و همینطور
        نحوه لینک سازی پیدا کنه.
      </p>
    ),
    count_page_internal_total: (
      <p>
        تعداد کل پیوندها یا لینک‌های داخلی که در سایت وجود داره، پیوندهای تکراری
        هم شامل میشه.
      </p>
    ),
    count_page_external_total: (
      <p>
        تعداد کل پیوندها یا لینک‌های خارجی که در سایت وجود داره، پیوندهای تکراری
        هم شامل میشه.
      </p>
    ),
    count_resource_total: (
      <p>
        شامل تصاویر، فایل‌های CSS و JS که یکتا هستند یعنی تکراری ها رو حساب
        نمی‌کنیم.
      </p>
    ),
    data_retention: (
      <p>در تاریخ اشاره شده اطلاعات خزش به صورت خودکار پاک میشه.</p>
    ),
    status_code: (
      <p>
        این کد ها از طریق سرور به مروگر ارسال میشه و وضعیت دسترسی به صفحات یا
        منابع سایت شما رو مشخص میکنه. اگر این کد با ۲ شروع بشه یعنی وضعیت نشانی
        بدون مشکل لود میشه و اگر با ۳ شروع میشه یعنی ریدایرکت صورت گرفته، اگر با
        ۴ شروع بشه یعنی یک خطایی سمت کاربر هست و اگر با ۵ شروع بشه یعنی خطایی
        سمت سرور هست.
      </p>
    ),
    is_4xx: (
      <p>
        وقتی نشانی خطایی از نوع 4XX داشته باشه یعنی خطا سمت کاربر هست و باید این
        خطا رو بررسی و حل کنید، معروف‌ترین خطای سری ۴{' '}
        <a
          href="https://mizfa.tools/article/how-to-fix-wordpress-404-error/"
          target="_blank"
          rel="noreferrer noopener"
        >
          خطای ۴۰۴
        </a>
        هست.
      </p>
    ),
    is_5xx: (
      <p>
        وقتی نشانی خطایی از نوع ۵xx داشته باشه یعنی خطا سمت سرور هست و باید این
        خطا رو بررسی و حل کنید.
      </p>
    ),
    uri_issue: (
      <p>
        مشکلات ساختاری نشانی (مثل آندرلاین، حروف بزرگ، کوئری و …) که در خزش
        تشخیص داده شده. روی متن هر مورد در جدول بروید تا توضیح همان مسئله را
        ببینید؛ اگر چند مورد باشد روی عدد نگه دارید.
      </p>
    ),
    response_time: (
      <p>زمان پاسخ یا (Response Time) مدت زمانی هست که صفحه شما لود شده</p>
    ),
    length_html: (
      <p>
        اندازه یا حجم نشانی رو نشون میده، اگر یک صفحه html باشه فقط اندازه خود
        صفحه html رو نشون میده و فایل‌های داخل اون مثل css یا js یا تصاویر شاملش
        نیست.
      </p>
    ),
    is_size_high: (
      <p>
        اگر حجم مدیا (عکس، فیلم، صوت) و یا فایل های درون صفحه (CSS, Js , ...) یا
        خود صفحه هست؟ اگر باشه در این ستون میگیم.
      </p>
    ),
    header_key: (
      <p>
        اصولا هر درخواست یک سری هدرها داره به اونا HTTP headers میگیم که در این
        بخش نمایش میدیم. چون تعداد هدرها زیاد هست فقط تعداد هر هدر رو نمایش
        میدیم و برای مشاهده اون باید روی عدد نمایش داده شده کلیک کنی
      </p>
    ),
    title: (
      <p>
        نمایش مقدار تگ عنوان، اسم‌های دیگه این تگ هست: عنوان سئو، عنوان صفحه،
        عنوان گوگل یا Title Tag که در کل اهمیت بالایی در سئوی یک صفحه از سایت
        داره.
      </p>
    ),
    title_not_using: (
      <p>
        آیا این نشانی مقداری برای تگ عنوان (عنوان سئو یا Title Tag هم میگن) داره
        یا نه. نشانی‌هایی که عنوان ندارن حتما باید توسط متخصص سئو بررسی شن.
      </p>
    ),
    title_count: (
      <p>
        تعداد تگ عنوان (عنوان سئو یا Title Tag هم میگن) که برای این صفحه نوشتید
        رو نمایش میده، اگر ۲ یا بالاتر باشه یعنی خطای سئویی دارید.{' '}
      </p>
    ),
    title_several_using: (
      <p>
        اگر بیشتر از یک تگ عنوان (عنوان سئو یا Title Tag هم میگن) برای صفحه
        نوشته باشید با رنگ قرمز به شما نمایش میده و باید بررسی کنید.{' '}
      </p>
    ),
    title_have_emoji: (
      <p>
        اگر در تگ عنوان (عنوان سئو یا Title Tag هم میگن) از ایموجی استفاده کرده
        باشید با رنگ قرمز به شما نمایش میده، این مورد خطا نیست صرفا یک اطلاعیه
        هست.{' '}
      </p>
    ),
    title_most_repeated_word: (
      <p>
        چه کلماتی در تگ عنوان (عنوان سئو یا Title Tag هم میگن) بیش از اندازه
        استفاده شده؟ در این بخش نمایش میدیم.{' '}
      </p>
    ),
    title_not_using_in_text: (
      <p>
        چه کلماتی در تگ عنوان (عنوان سئو یا Title Tag هم میگن) استفاده شده ولی
        در متن صفحه از اون استفاده نکردید با رنگ قرمز به شما نمایش میده{' '}
      </p>
    ),
    title_not_using_in_text_count: (
      <p>
        تعداد کلماتی که در تگ عنوان (عنوان سئو یا Title Tag هم میگن) استفاده شده
        ولی در متن صفحه استفاده نشده به شما نمایش میده{' '}
      </p>
    ),
    title_have_archive: (
      <p>
        آیا در تگ عنوان (عنوان سئو یا Title Tag هم میگن) از کلمات آرشیو دار
        استفاده شده؟ وقتی استفاده شده باشه یعنی شما عنوان‌های پیش فرض وردپرس رو
        تغییر ندادید و از نظر سئو اهمیتی به این نشانی ندادید، در این صورت باید
        حتما نشانی رو بررسی کنید.{' '}
      </p>
    ),
    title_char: (
      <p>
        تعداد کاراکتری که برای نوشتن تگ عنوان (عنوان سئو یا Title Tag هم میگن)
        استفاده کردید نمایش میده
      </p>
    ),
    title_px: (
      <p>
        تعداد پیکسلی که برای نوشتن تگ عنوان (عنوان سئو یا Title Tag هم میگن)
        استفاده کردید نمایش میده
      </p>
    ),
    title_char_is_long: (
      <p>
        شما مجاز هستید حداکثر ۶۰ کاراکتر برای تگ عنوان (عنوان سئو یا Title Tag
        هم میگن) بنویسید. اگر تعداد کاراکتر استفاده شده بیشتر باشه با رنگ قرمز
        به شما نمایش میده.{' '}
      </p>
    ),
    title_px_is_long: (
      <p>
        شما مجاز هستید حداکثر ۶۰۰ پیکسل برای تگ عنوان (عنوان سئو یا Title Tag هم
        میگن) بنویسید. اگر تعداد پیکسل بیشتر باشه با رنگ قرمز به شما نمایش میده.{' '}
      </p>
    ),
    title_char_is_short: (
      <p>
        شما می‌تونید تا ۶۰ کاراکتر برای تگ عنوان (عنوان سئو یا Title Tag هم
        میگن) بنویسید. اگر کم‌تر بنویسید رقبا از این ضعف شما استفاده میکنن، اگر
        تعداد کاراکتر استفاده شده خیلی کمتر باشه با رنگ قرمز به شما نمایش میده.{' '}
      </p>
    ),
    title_px_is_short: (
      <p>
        شما می‌تونید تا ۶۰۰ پیکسل برای تگ عنوان (عنوان سئو یا Title Tag هم میگن)
        بنویسید. اگر کم‌تر بنویسید رقبا از این ضعف شما استفاده میکنن، اگر تعداد
        کاراکتر استفاده شده خیلی کمتر باشه با رنگ قرمز به شما نمایش میده.{' '}
      </p>
    ),
    meta_desc: <p>نمایش توضیح متا نشانی (Meta Description)</p>,
    meta_desc_not_using: (
      <p>
        مشخص میکنه برای این نشانی نمایش توضیح متا (Meta Description) نوشتید یا
        نه. اگر این صفحه توضیح متا نداشته باشه با رنگ قرمز به شما نمایش میده
      </p>
    ),
    meta_desc_char: (
      <p>
        تعداد کاراکتری که برای نوشتن توضیح متا (Meta Description) استفاده کردید
        نمایش میده
      </p>
    ),
    meta_desc_count: (
      <p>
        تعداد توضیح متا (Meta Description) که برای این نشانی وجود داره رو نمایش
        میده و اگر تعداد ۲ یا بالاتر بود یک خطای سئویی به حساب میاد.
      </p>
    ),
    meta_desc_px: (
      <p>
        مقدار پیکسلی که برای نوشتن توضیح متا (Meta Description) برای نشانی
        استفاده شده رو نمایش میده
      </p>
    ),
    meta_desc_char_is_long: (
      <p>
        شما مجاز هستید حداکثر ۱۵۵ الی ۱۶۰ کاراکتر برای توضیح متا (Meta
        Description) بنویسید. اگر تعداد کاراکتر استفاده شده بیشتر باشه با رنگ
        قرمز به شما نمایش میده.
      </p>
    ),
    meta_desc_px_is_long: (
      <p>
        شما مجاز هستید تا ۹۲۰ پیکسل برای توضیح متا (Meta Description) بنویسید.
        اگر تعداد پیکسل بیشتر باشه با رنگ قرمز به شما نمایش میده.
      </p>
    ),
    meta_desc_char_is_short: (
      <p>
        شما می‌تونید تا ۱۵۵ کاراکتر برای توضیح متا (Meta Description) بنویسید.
        اگر تعداد کاراکتر استفاده شده خیلی کمتر باشه با رنگ قرمز به شما نمایش
        میده و بهتره بیشتر بنویسید تا در نتایج گوگل حرف بیشتری برای گفتن داشته
        باشید.
      </p>
    ),
    h1: <p>مقدار H1 یا تیتر یک نشانی رو نمایش میده</p>,
    h1_count: (
      <p>
        تعداد H1 هایی که در صفحه وجود داره نمایش میده، پیشنهاد میشه در هر نشانی
        از یک H1 استفاده کنید.
      </p>
    ),
    h1_not_using_in_text: (
      <p>
        کلماتی که در مقدار H1 یا تیتر یک استفاده کردید ولی در متن صفحه استفاده
        نشده رو با رنگ قرمز به شما نمایش میده
      </p>
    ),
    h1_not_using_in_text_count: (
      <p>
        تعداد کلماتی که در مقدار H1 یا تیتر یک استفاده کردید ولی در متن صفحه
        استفاده نشده رو شما نمایش میده
      </p>
    ),
    h1_not_using: (
      <p>
        آیا این نشانی مقدار H1 یا تیتر یک داره یا نه. اگر نداشته باشه با رنگ
        قرمز به شما نمایش میده
      </p>
    ),
    h2: <p>مقدار H2 یا تیتر دو نشانی رو نمایش میده</p>,
    h2_count: <p>تعداد H2 هایی که در صفحه وجود داره نمایش میده</p>,
    h2_not_using_in_text: (
      <p>
        کلماتی که در مقدار H2 یا تیتر دو استفاده کردید ولی در متن صفحه استفاده
        نشده رو با رنگ قرمز به شما نمایش میده
      </p>
    ),
    h2_not_using_in_text_count: (
      <p>
        تعداد کلماتی که در مقدار H2 یا تیتر دو استفاده کردید ولی در متن صفحه
        استفاده نشده رو شما نمایش میده
      </p>
    ),
    h2_not_using: (
      <p>
        آیا این نشانی مقدار H2 یا تیتر دو داره یا نه. اگر نداشته باشه با رنگ
        قرمز به شما نمایش میده
      </p>
    ),
    h3: <p>مقدار H3 یا تیتر سه نشانی رو نمایش میده</p>,
    h3_count: <p>تعداد H3 هایی که در صفحه وجود داره نمایش میده</p>,
    h3_not_using_in_text: (
      <p>
        کلماتی که در مقدار H3 یا تیتر سه استفاده کردید ولی در متن صفحه استفاده
        نشده رو با رنگ قرمز به شما نمایش میده
      </p>
    ),
    h3_not_using_in_text_count: (
      <p>
        تعداد کلماتی که در مقدار H3 یا تیتر سه استفاده کردید ولی در متن صفحه
        استفاده نشده رو شما نمایش میده
      </p>
    ),
    h3_not_using: (
      <p>
        آیا این نشانی مقدار H3 یا تیتر سه داره یا نه. اگر نداشته باشه با رنگ
        قرمز به شما نمایش میده
      </p>
    ),
    canonical_url: <p>نشانی یا آدرس کنونیکال صفحه رو نشون میده</p>,
    canonical_url_status_code: (
      <p>
        وضعیت نشانی یا آدرس کنونیکال صفحه رو نشون میده، اگر غیر ۲۰۰ بود حتما
        کنونیکال اون صفحه رو یک بررسی دقیق داشته باشید.
      </p>
    ),
    canonical_is_itself: (
      <p>
        وضعیت داشتن تگ کنونیکال صفحه را مشخص میکنه و اینکه آیا این کنونیکال به
        خود صفحه هست یا صفحه دیگر، اگر تگ کنونیکال نداره یعنی اصولا به خودش
        کنونیکال شده اگر عبارت "داره به خود" داخل جدول بود یعنی تگ کنونیکال داره
        و خود نشانی صفحه هم داخل کنونیکال هست و اگر عبارت "داره به غیر" بود باید
        بررسی کنید که آدرس کنونیکال چرا با آدرس صفحه سایت یکی نیست و آیا درسته
        یا نه.
      </p>
    ),
    canonical_is_not_itself: (
      <p>
        اگر صفحه شما به صفحه ای غیر از خودش کنونیکال شده باش با رنگ قرمز به شما
        نمایش میده، بهتره در این حالت بررسی کنید که علت چی هست و اگر مشکلی نبود
        رها کنید و اگر مشکل بود مقدار کنونیکال صفحه رو ویرایش کنید.
      </p>
    ),
    rel_next: (
      <p>
        هر جا که صفحه‌بندی دارید باید اون صفحه اتریبیوت rel=next داشته باشه و در
        سئو نقش مهمی داره
      </p>
    ),
    rel_prev: (
      <p>
        هر جا که صفحه‌بندی دارید باید اون صفحه اتریبیوت rel=prev داشته باشه و در
        سئو نقش مهمی داره
      </p>
    ),
    robots_is_noindex: (
      <p>
        اگر نشانی (صفحه مد نظر) نوایندکس بود یعنی این نشانی نمی‌تونه در نتایج
        گوگل باشه. مقادیر این بخش از متاتگ robots دریافت شده.{' '}
      </p>
    ),
    robots_is_nofollow: (
      <p>
        اگر نشانی (صفحه مد نظر) نوفالو بود یعنی کل پیوندهای این صفحه نوفالو هست
        و ربات‌ها امکان دنبال کردن پیوندها از طریق این صفحه رو ندارن.{' '}
      </p>
    ),
    is_3xx: (
      <p>
        اگر صفحه شما به صفحه دیگری ریدایرکت شده باشه با رنگ قرمز به شما نمایش
        میده
      </p>
    ),
    redirect_url: <p>آدرس صفحه ای که صفحه شما بهش ریدایرکت شده نمایش میده</p>,
    redirect_is_chain: (
      <p>
        ریدایرکت پیوسته یعنی کاربر از صفحه A به B از صفحه B به C و از صفحه C به
        D ریدایرکت میشه. درحالی که میشد از صفحه A مستقیم کاربر رو به صفحه D
        انتقال داد.
      </p>
    ),
    redirect_is_loop: (
      <p>
        ریدایرکت لوپ یا حلقه‌ای یعنی کاربر از صفحه A به B از صفحه B دوباره به A
        میره و این مسیر همش تکرار میشه. inlink_count
      </p>
    ),
    inlink_count: (
      <p>
        یعنی از سایر صفحات به این نشانی چقدر لینک شده، اصولا در دنیای سئو به این
        مورد inline هم گفته میشه.
      </p>
    ),
    unique_inlink_count: (
      <p>
        مثل تعداد پیوند داخلی شده هست ولی تکراری ها حذف شدن و این مورد کمک میکنه
        تا متوجه بشید چقدر پیوند داخلی واقعی که تکراری نیست به صفحه پیوند شده.
        is_low_unique_inlink{' '}
      </p>
    ),
    is_low_unique_inlink: (
      <p>
        به صفحاتی گفته میشه که پیوند داخلی بهشون کم شده یعنی از سایر صفحات بهش
        کمتر لینک شده، اصولا به صفحه تنها در دنیای سئو صفحات یتیم هم گفته میشه
        ولی صفحه تنها اسم قشنگ‌تری هست.
      </p>
    ),
    outlink_internal_count: (
      <p>
        از نشانی چه تعداد پیوند داخلی یا لینک داخلی به سایر صفحات خود دامنه صورت
        گرفته.
      </p>
    ),
    unique_internal_outlink_count: (
      <p>مثل پیوند داخل کرده هست ولی تکراری ها حذف شدن</p>
    ),
    outlink_external_count: (
      <p>
        از نشانی چه تعداد پیوند خارجی یا لینک خارجی به سایر صفحات خود دامنه صورت
        گرفته.
      </p>
    ),
    unique_external_outlink_count: (
      <p>مثل پیوند خارجی کرده هست ولی تکراری ها حذف شدن</p>
    ),
    is_page_high_unique_external_outline: (
      <p>
        اگر در صفحه بیشتر از حد استاندارد لینک خارجی (پیوند خارجی کرده) داشته
        باشید با رنگ قرمز به شما نمایش میده
      </p>
    ),
    depth: (
      <p>
        یعنی ربات گوگل چقدر باید صفحات مختلف رو طی کنه و چند پیوند رو باید بررسی
        کنه تا در نهایت به این نشانی برسه؟ هر چی عدد بالاتر باشه بدتره مثلا
        عددهای ۳۰ به بالا حتما باید یک بررسی داشته باشید مگر براتون این صفحات با
        عدد بالا مهم نباشن.
      </p>
    ),
    is_depth_high: <p>صفحاتی که عمق زیادی دارن</p>,
    density_words_1: <p>تک کلماتی که بیشترین تکرار رو در اون نشانی دارن.</p>,
    density_words_2: <p>دو کلماتی که بیشترین تکرار رو در اون نشانی دارن.</p>,
    density_words_3: <p>سه کلماتی که بیشترین تکرار رو در اون نشانی دارن.</p>,
    image_count: <p>تعداد تصاویری که در نشانی استفاده شده رو نمایش میده</p>,
    css_count: <p>تعداد فایل‌های CSS که در نشانی استفاده شده رو نمایش میده</p>,
    js_count: <p>تعداد فایل‌های JS که در نشانی استفاده شده رو نمایش میده</p>,
    low_word: (
      <p>
        اگر محتوای نشانی شما از حد استاندارد کمتر باشه با رنگ قرمز به شما نمایش
        میده
      </p>
    ),
    high_word: (
      <p>
        اگر محتوای نشانی شما از حد استاندارد بیشتر باشه با رنگ قرمز به شما نمایش
        میده
      </p>
    ),
    word_count: (
      <p>
        تعداد کل کلماتی که در این صفحه استفاده کردید به شما نمایش میده، کلمات
        داخل فوتر و منو و سایدبار حذف شدن
      </p>
    ),
    unique_words_count: (
      <p>
        تعداد کلمات یکتا و یا منحصر به فردی که در این صفحه استفاده کردید به شما
        نمایش میده. مثلا اگر از یک کلمه چندین بار استفاده کرده باشید فقط یکبار
        محاسبه میشه
      </p>
    ),
    char_count: (
      <p>
        تعداد کل کاراکتری که برای نوشتن محتوای این صفحه استفاده کردید به شما
        نمایش داده میشه
      </p>
    ),
    sentence_count: (
      <p>
        تعداد جملاتی که برای نوشتن محتوای این صفحه استفاده کردید به شما نمایش
        داده میشه
      </p>
    ),
    reading_time: (
      <p>
        مدت زمان تقریبی برای خواندن محتوای صفحه بر حسب دقیقه رو به شما نمایش
        میده
      </p>
    ),
    published_time: <p>زمان انتشار این صفحه در سایت رو به شما نمایش میده</p>,
    last_modified: (
      <p>تاریخ آخرین باری که این صفحه ویرایش شده به شما نمایش میده</p>
    ),
    last_modified_by_day: (
      <p>تعداد روزی که این صفحه آپدیت نشده رو نمایش میده</p>
    ),
    old_blog: <p>اگر مقاله قدیمی شده با رنگ قرمز به شما میگه قدیمی شده</p>,
    type: (
      <p>
        نوع نشانی رو میده انواع نشانی عبارت اند از: صفحه داخلی، صفحه خارجی، فایل
        CSS یا JS یا تصویر
      </p>
    ),
    protocol: (
      <p>نوع پروتکل صفحه که از نوع http هست یا https را به شما نمایش میده.</p>
    ),
    content_type: (
      <p>
        این نشانی چه محتوایی هست؟ یعنی نشانی یک صفحه هست؟ یا تصویر یا یک فایل
        CSS یا JS هست؟ در این ستون می‌تونیم نوع این محتوا رو متوجه بشیم، نوع
        محتوا از درخواست‌های هدر گرفته میشه.
      </p>
    ),
    lang: (
      <p>
        زمان صفحه از تگ html ویژگی lang گرفته میشه مثلا زمانی که مقدار اون fa-IR
        هست یعنی زبان صفحه فارسی ایران هست، اصولا این ویژگی به ربات‌های گوگل کمک
        میکنه تا سریع‌تر زبان یک صفحه رو متوجه بشه.
      </p>
    ),
    domain_link: (
      <p>نوع پروتکل صفحه که از نوع http هست یا https را به شما نمایش میده.</p>
    ),
    link_href: (
      <p>نوع پروتکل صفحه که از نوع http هست یا https را به شما نمایش میده.</p>
    ),
    link_text: (
      <p>نوع پروتکل صفحه که از نوع http هست یا https را به شما نمایش میده.</p>
    ),
    link_text_bad: (
      <p>نوع پروتکل صفحه که از نوع http هست یا https را به شما نمایش میده.</p>
    ),
    link_href_type: (
      <p>نوع پروتکل صفحه که از نوع http هست یا https را به شما نمایش میده.</p>
    ),
    link_3xx_destination: (
      <p>نوع پروتکل صفحه که از نوع http هست یا https را به شما نمایش میده.</p>
    ),
    link_href_protocol: (
      <p>نوع پروتکل صفحه که از نوع http هست یا https را به شما نمایش میده.</p>
    ),
    http_links_on_https: (
      <p>
        اگر پروتکل صفحه شما از نوع https باشد و لینکی که در صفحه هست از نوع http
        با رنگ قرمز به شما نمایش میده.
      </p>
    ),

    link_is_nofollow: (
      <p>
        لینک هایی با ویژگی rel=nofollow لینک هایی هستند که به وسیله اونها شما به
        موتور های جستجو اعلام میکنید که این لینک ها را در نظر نگیرند و آنها را
        خزش نکنند. اگر پیوند صفحه از نوع nofollow باشه به شما نمایش میده
      </p>
    ),
    link_is_noopener: (
      <p>
        لینک هایی با ویژگی rel= noopener لینک هایی هستند که به وسیله اونها دیگر
        امکان انتقال اطلاعات و داده ها به پنجره جدید در جاوا اسکریپت از بین
        میرود و امنیت وب سایت را در برابر آسیب های احتمالی تامین میکند. اگر لینک
        شما این ویژگی را داشته باشه به شما نمایش میده
      </p>
    ),
    link_is_noreferrer: (
      <p>
        لینک هایی با ویژگی rel= noreferrer لینک هایی هستند که به وسیله اونها از
        ارسال آدرس صفحه وب ارجاع توسط مرورگر جلوگيري میشه یعنی اطلاعات لینک‌های
        شما در تحلیل و بررسی سایت مقصد پنهان می مونه. اگر لینک شما این ویژگی را
        داشته باشه به شما نمایش میده
      </p>
    ),
    link_is_ugc: (
      <p>
        لینک هایی با ویژگی rel= ugc لینک هایی هستند توسط کاربران در بخش های
        مختلف سایت مثل نظرات، مقاله ها و یا انتهای پست ها نوشته شده اند. اگر
        لینک شما این ویژگی را داشته باشه به شما نمایش میده
      </p>
    ),

    link_is_sponsored: (
      <p>
        لینک هایی با ویژگی rel= sponsored لینک هایی هستند که به وسیله اونها به
        موتور های جستجو اعلام میشه هدف از ایجاد این لینک های تبلیغات یا حمایت
        مالی هست و این لینک ها در ازای دریافت مبلغ در سایت شما قرار گرفته
        اند.اگر لینک شما این ویژگی را داشته باشه به شما نمایش میده
      </p>
    ),
    link_is_external: <p>لینک هایی با ویژگی rel= external هستند.</p>,
    link_is_alternate: (
      <p>
        لینک هایی با ویژگی rel= alternete لینک هایی هستند که به وسیله اونها به
        موتور های جستجو اعلام میشه سایت دو زبانه است و فقط محتوای داخل آن ترجمه
        شده. اگر لینک شما این ویژگی را داشته باشه به شما نمایش میده.
      </p>
    ),
    link_is_tag: (
      <p>
        لینک هایی با ویژگی rel= tag لینک هایی هستند که به وسیله اونها کلمات
        کلیدی مقاله به موتور های جستجو معرفی میشه. اگر لینک شما این ویژگی را
        داشته باشه به شما نمایش میده.
      </p>
    ),
    link_is_publisher: <p>لینک هایی با ویژگی rel= publisher هستند.</p>,
    link_is_license: (
      <p>
        لینک هایی با ویژگی rel= license لینک هایی هستند که آدرس آنها صفحه کپی
        رایت مقاله هست. اگر لینک شما این ویژگی را داشته باشه به شما نمایش میده.
      </p>
    ),
    link_is_author: (
      <p>
        لینک هایی با ویژگی rel= author لینک هایی هستند که به وسیله اونها به
        موتور های جستجو اعلام میشه نویسنده مقاله چه کسی هست. اگر لینک شما این
        ویژگی را داشته باشه به شما نمایش میده.
      </p>
    ),
    link_is_bookmark: (
      <p>
        لینک هایی با ویژگی rel= bookmark لینک هایی هستند که زمان ذخیره در مرورگر
        به عنوان بوک مارک تغییری نمیکن. اگر لینک شما این ویژگی را داشته باشه به
        شما نمایش میده.
      </p>
    )
  }
};
